import * as XLSX from "xlsx";

export const ExportToExcel = (
  data: any[],
  sheetName: string,
  excludeColumns?: any[]
) => {
  const newData = data.map((item) => {
    const newItem: any = { ...item };
    if (excludeColumns) {
      excludeColumns.forEach((col) => {
        delete newItem[col];
      });
    }
    return newItem;
  });

  const worksheet = XLSX.utils.json_to_sheet(newData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  return blob;
};
